<template>
  <v-bottom-sheet v-model="sheet">
    <v-btn flat icon slot="activator" color="primary">
      <v-icon>settings</v-icon>
    </v-btn>
    <v-layout row wrap>
      <v-flex
        text-left
        v-for="(column, index) in matrix.length"
        :key="index"
      >
        <v-list>
          <v-list-tile
            v-for="item in matrix[index]"
            :key="item.name"
            @click="sheet = false"
          >
            <v-icon class="px-2" :color="item.color">{{ item.icon }}</v-icon>
            <v-list-tile-title
              >{{ item.name }} : {{ item.value }}
              {{ item.unit }}</v-list-tile-title
            >
          </v-list-tile>
        </v-list>
        <v-divider inset vertical></v-divider>
      </v-flex>
    </v-layout>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: {
    matrix: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      sheet: false
    }
  }
}
</script>
